<template>
  <div class="form-hero">
    <slot></slot>
  </div>
</template>

<script>
export default {
  mounted() {
    var fields = this.$el.querySelector('.form-hero__fields')
    var submit = this.$el.querySelector('.form-hero__submit')
    this.$el.querySelector('form').addEventListener('submit', function(e) {
      e.preventDefault()
      // TODO: add an ajax call to do something...
      // replace the form content with a success message
      console.log(
        'Saving value',
        this.$el.querySelector('form').elements.value.value
      )
      if (fields) {
        fields.innerHTML = 'Success! Thank you for your submission.'
        fields.style.alignSelf = 'center'
      }
      if (submit) {
        submit.style.visibility = 'hidden'
      }
    })
  },
}
</script>
